import * as tslib_1 from "tslib";
import { AssetEvent } from "@awayjs/core";
import { MappingMode } from "@awayjs/graphics";
import { ShaderChunkBase } from "./ShaderChunkBase";
/**
 * AmbientBasicChunk provides the default shading method for uniform ambient lighting.
 */
var AmbientBasicChunk = (function (_super) {
    tslib_1.__extends(AmbientBasicChunk, _super);
    /**
     * Creates a new AmbientBasicChunk object.
     */
    function AmbientBasicChunk(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this._method = method;
        _this._shader = shader;
        return _this;
    }
    /**
     *
     */
    AmbientBasicChunk.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        this._method = null;
        this._shader = null;
        if (this._texture) {
            this._texture.onClear(new AssetEvent(AssetEvent.CLEAR, this._method.texture));
            this._texture = null;
        }
    };
    /**
     * @inheritDoc
     */
    AmbientBasicChunk.prototype._initVO = function (chunkVO) {
        if (this._method.texture) {
            this._texture = this._shader.getAbstraction(this._method.texture);
            if (this._method.texture.mappingMode == MappingMode.CUBE)
                chunkVO.needsNormals = true;
            else
                this._shader.uvDependencies++;
        }
        else if (this._texture) {
            this._texture = null;
        }
    };
    /**
     * @inheritDoc
     */
    AmbientBasicChunk.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var code = "";
        if (this._texture) {
            code += this._texture._getFragmentCode(targetReg, registerCache, sharedRegisters, (this._method.texture.mappingMode == MappingMode.CUBE) ? sharedRegisters.normalFragment : sharedRegisters.uvVarying);
            if (this._shader.alphaThreshold > 0) {
                var cutOffReg = registerCache.getFreeFragmentConstant();
                this._colorIndex = cutOffReg.index * 4;
                code += "sub " + targetReg + ".w, " + targetReg + ".w, " + cutOffReg + ".x\n" +
                    "kil " + targetReg + ".w\n" +
                    "add " + targetReg + ".w, " + targetReg + ".w, " + cutOffReg + ".x\n";
            }
        }
        else {
            var ambientInputRegister = registerCache.getFreeFragmentConstant();
            this._colorIndex = ambientInputRegister.index * 4;
            code += "mov " + targetReg + ", " + ambientInputRegister + "\n";
        }
        return code;
    };
    /**
     * @inheritDoc
     */
    AmbientBasicChunk.prototype._activate = function () {
        if (this._texture) {
            this._texture.activate();
            if (this._invalid && this._shader.alphaThreshold > 0)
                this._shader.fragmentConstantData[this._colorIndex] = this._shader.alphaThreshold;
        }
        else if (this._invalid) {
            var index = this._colorIndex;
            var data = this._shader.fragmentConstantData;
            var color = this._shader.numLights ? 0xFFFFFF : this._shader.pass.style.color;
            data[index] = ((color >> 16) & 0xff) / 0xff * this._method.strength;
            data[index + 1] = ((color >> 8) & 0xff) / 0xff * this._method.strength;
            data[index + 2] = (color & 0xff) / 0xff * this._method.strength;
            data[index + 3] = this._method.alpha;
        }
    };
    AmbientBasicChunk.prototype._setRenderState = function (renderable, projection) {
        if (this._texture)
            this._texture._setRenderState(renderable);
    };
    return AmbientBasicChunk;
}(ShaderChunkBase));
export { AmbientBasicChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/AmbientBasicChunk.js